import style from "./CommentSection.module.css";
import { useGetUnitComments } from "../../hooks/useGetUnitComments";

import PostCommentForm from "../postCommentForm/PostCommentForm";
import ParentComment from "../parentComment/ParentComment";
import { useUser } from "@/features/auth/hooks/useUser";

import EmptySection from "@/ui/emptySection/EmptySection";

function CommentSection({ video }) {
	const { comments, isSuccess, isPending, isError, error } =
		useGetUnitComments({ unit: video });

	const { isLoggedIn } = useUser();

	if (isPending) return <>Učitavanje...</>;
	if (isError) return <>Error: {JSON.stringify(error)}</>;

	return (
		<div className={style.commentSectionHolder}>
			<div className={style.commentSection}>
				{isLoggedIn && <PostCommentForm video={video} />}
				<ul className={style.commentsHolder}>
					{comments.length === 0 && (
						<p className="text-center">Trentuno nema komentara</p>
					)}
					{comments.map((comment) => (
						<ParentComment
							unit={video}
							comment={comment}
							key={comment.uuid}
						/>
					))}
				</ul>
			</div>
		</div>
	);
}

export default CommentSection;
